export default __webpack_public_path__ + "static/media/savy.d3e166ef.png";